export const pageTitleAndDescription = [
  {
    page: 'Home',
    url: '/',
    title: 'Givebacks - Support the causes you care about',
    description:
      'Automatic cashback for you and your cause, in store, online, and on your phone - join the movement where shopping is the right thing to do.',
  },
  {
    page: 'Why Givebacks',
    url: '/story',
    title: 'Givebacks - About Us',
  },
  {
    page: 'All Offers',
    url: '/offers',
    title: 'Givebacks - All Offers',
  },
  {
    page: 'Local Offers',
    url: '/offers/local',
    title: 'Givebacks - Local Offers',
  },
  {
    page: 'Online Offers',
    url: '/offers/online',
    title: 'Givebacks - Online Offers',
  },
  {
    page: 'Claimed Offers',
    url: '/offers/claimed',
    title: 'Givebacks - Claimed Offers',
  },
  {
    page: 'Wallet',
    url: '/wallet',
    title: 'Givebacks - Wallet',
  },
  {
    page: 'Profile',
    url: '/profile',
    title: 'Givebacks - Profile',
  },
  {
    page: 'Causes',
    url: '/causes',
    title: 'Givebacks - Causes',
  },
  {
    page: 'Cause Page',
    url: '/causes/detail/:uuid',
    title: 'Support {cause.name} on Givebacks',
    description:
      "Support {cause.name} on Givebacks by shopping at the places you normally shop. You'll get up to 10% cashback while giving up to 1% to {cause.name}",
  },
];
